<template>
  <FormulaireChat
    :chat-initial="chat"
    mode="modification"
    @sauvegarder="handleSauvegarder"
    @annuler="$emit('fermer')"
    @fermer="$emit('fermer')"
  />
</template>

<script setup>
import { ref } from 'vue';
import FormulaireChat from './FormulaireChat.vue';

const props = defineProps({
  chat: { type: Object, required: true }
});
const emit = defineEmits(['sauvegarder', 'fermer']);

const message = ref("");

function handleSauvegarder(chatModifie, msg) {
  message.value = msg || "Chat modifié avec succès !";
  emit('sauvegarder', chatModifie);
  // Affiche le message dans ce composant ou le passe au parent comme tu veux
  console.log(message.value);
}
</script>
